<template>
	<!-- 
		ui-input-handler | UI Input handler

		@requiere: 
		+ ui-edit-auto-modal@1.18.0 o superior

		Version 1.21.0
		Pase directo desde args, filters y formAsArgs desde Archetype y Quicktable según sea el caso.

		Date: Feb, 11, 2025
		Author: Daniel Lepe

		Version 1.20.0
		Integración con groupingDefinition

		Version 1.18.5
		Integra propiedades de readonly y required para quicktableSelect.

		Version 1.18.4
		Corregido un error de CSS para la ocultación del chevron-down de los selects

		Version 1.18.3
		Agregada la propiedad de HASH para tener control absoluto del id del input generado.

		Version 1.18.2
		Ocultado de arrows en selects

		Version 1.18.1
		Corrección de error de visualización de texto en SELECT.

		Version 1.18.0
		Agregada propiedad kIndex, usado principalmente por quicktableSelect

		Version 1.17.0
		Markdown type #Bugfix (Requiere simplemde@1.11, marked@4)

		Version 1.16.1
		Quicktable-Select #Bugfix

		Version 1.16
		Actualización con quicktable-select

		Version 1.15
		Preselección de mobiscroll, abierta para objeto / string en array de opciones de tipo SELECT.

		Version 1.14 
		Change FIX

		Version 1.13 
		Auto mobiscroll con autofilter para listas de selects largos. :D

		Version 1.12.2 - No ID display

		Version 1.12.1 - No Source
		Remoción de concepto source

		Version 1.12
		Tipos de input validados según referencia HTML5

		Version 1.11
		Corrige un error que obligaba el valor default desde una edición desde fuera del modal.

		Version 1.10
		Corrige un error que impedía la precarga desde el componente default del valor 
		de la propiedad.

		Version 1.9
		Ajustes para el formato de "selectmultiple"

		Version 1.8
		Permite el formato de "selectmultiple"

		Version 1.7
		Corrección de prelectura de requerimiento

		Version 1.6
		Added percent form model

		Version 1.5
		bFormSelect utiliza la propiedad disabled cuando vienen en modo readonly

		Version 1.4
		Actualiza el valor de workingValue en función de value de manera automática

		Version 1.3
		Permite markdown (Requiere simplemde@1.11, marked@4)

		Version 1.2
		Permite positivos únicamente


		Version 1.1

		Permite checkbox

		Version 1.0

		Date: 01/03/2022
		Author: Daniel Lepe
	-->
	<div class="ui-input-handler" v-if="fArch.type != 'hidden'">

		<RemoteSelect v-if="fArch.type == 'remoteSelect'" v-model="workingValue" :label="finalLabel"
			:remote="fArch.remote" :allow-grouping="fArch.remoteCfg.allowGrouping"
			:data-group="fArch.remoteCfg.dataGroup" :allow-filter="fArch.remoteCfg.allowFilter"
			:multiline="fArch.remoteCfg.multiline" :readonly="fArch.readonly" />

		<b-form-group v-else-if="fArch.key != 'id' && fArch.type != 'checkbox' && fArch.type != 'markdown'"
			:class="fArch.type + ((fArch.readonly) ? ' readonly' : '')" :label="finalLabel" :label-for="currentId">

			<ui-grouping-definition v-if="fArch.type == 'groupingDefinition'" 
				v-model="workingValue" 
				:kIndex="kIndex"
				:key="'groupingDefinition-' + fArch.key"
				:id="currentId" 
				:label="finalLabel" 
				:fArchKey="fArch.key"
				:args="args"
				:readonly="fArch.readonly" 
				:required="fArch.required" 
				:options="grouping[fArch.key]"
				@changed="$emit('changed'); $emit('change');"/>

			<quicktable-select v-else-if="fArch.type == 'quicktableSelect'" v-model="workingValue" :kIndex="kIndex"
				:fullFormGetter="fullFormGetter"
				:fn-to-select-from-main-query-item="fnToSelectFromMainQueryItem" :key="'quicktable-' + fArch.key"
				:id="currentId" :quicktable="fArch.quicktable" :label="finalLabel" :valueName="fArch.valueName"
				:labelName="fArch.labelName" :options="fArch.options" :fArchKey="fArch.key"
				:args="args" 
				@changed="$emit('changed'); $emit('change');"
				:readonly="fArch.readonly" 
				:filters="('filters' in fArch) ? fArch.filters : null" 
				:formAsArgs="('formAsArgs' in fArch) ? fArch.formAsArgs : null"/>

			<b-form-textarea :id="currentId" :ref="currentId" v-model="workingValue" @blur="$emit('blur', $event)"
				@change="$emit('change', $event)" @focus="$emit('focus')" v-else-if="fArch.type == 'textarea'"
				:disabled="fArch.readonly" />

			<b-form-select :id="currentId" :ref="currentId" v-model="workingValue" @blur="$emit('blur', $event)"
				@change="$emit('change', $event)" @focus="$emit('focus')"
				v-else-if="fArch.type == 'select' || fArch.type == 'selectmultiple'"
				:multiple="fArch.type == 'selectmultiple'" :disabled="fArch.readonly" :readonly="fArch.readonly"
				:options="fArch.options" />

			<b-form-datepicker :id="currentId" :ref="currentId" v-model="workingValue" v-else-if="fArch.type == 'date'"
				@blur="$emit('blur', $event)" @change="$emit('change', $event)" @focus="$emit('focus')"
				:disabled="fArch.readonly" :date-disabled-fn="fArch.dateDisabledFn" :readonly="fArch.readonly" />

			<storage-img-uploader :id="'form-' + fArch.key" v-model="workingValue"
				v-else-if="fArch.type == 'imageurl' || fArch.type == 'storedimg'" :disabled="fArch.readonly"
				:readonly="fArch.readonly" label="false" :args="args" />

			<storage-file-uploader :id="'form-' + fArch.key" v-model="workingValue"
				v-else-if="fArch.type == 'fileurl' || fArch.type == 'storedfile' || fArch.type == 'file'" 
				:disabled="fArch.readonly"
				:readonly="fArch.readonly" 
				:label="false" 
				:args="args" />

			<img-input-autoload :id="currentId" :ref="currentId" v-model="workingValue"
				v-else-if="fArch.type == 'image'" 
				:args="args"
				:disabled="fArch.readonly" 
				:readonly="fArch.readonly" 
				label="false" />

			<b-input-group prepend="$" v-else-if="fArch.type == 'price'" :label="finalLabel" :label-for="currentId">
				<b-form-input :id="currentId" :ref="currentId" v-model="workingValue" @blur="$emit('blur', $event)"
					@change="$emit('change', $event)" @focus="$emit('focus')" type="number" :disabled="fArch.readonly"
					:readonly="fArch.readonly" :min="fArch.min" />
			</b-input-group>

			<b-input-group append="%" v-else-if="fArch.type == 'percent'" :label="finalLabel" :label-for="currentId">
				<b-form-input :id="currentId" :ref="currentId" v-model="workingValue" @blur="$emit('blur', $event)"
					@change="$emit('change', $event)" @focus="$emit('focus')" type="number" :disabled="fArch.readonly"
					:readonly="fArch.readonly" :min="fArch.min" />
			</b-input-group>

			<b-form-input :id="currentId" :ref="currentId" v-model="workingValue" @blur="$emit('blur', $event)"
				@change="$emit('change', $event)" @focus="$emit('focus')" v-else-if="fArch.type == 'positive'"
				type="number" :min="0" :disabled="fArch.readonly" :readonly="fArch.readonly"
				:minlength="fArch.minlength" :maxlength="fArch.maxlength" />

			<b-form-input :id="currentId" :ref="currentId" v-model="workingValue" @blur="$emit('blur', $event)"
				@change="$emit('change', $event)" @focus="$emit('focus')" v-else-if="fArch.type == 'decimal'"
				type="number" step="0.01" :disabled="fArch.readonly" :readonly="fArch.readonly"
				:minlength="fArch.minlength" :maxlength="fArch.maxlength" />

			<b-form-input :id="currentId" :ref="currentId" v-model="workingValue" @blur="$emit('blur', $event)"
				@change="$emit('change', $event)" @focus="$emit('focus')"
				v-else-if="['text', 'email', 'date', 'password', 'search', 'phone', 'url', 'range', 'color'].indexOf(fArch.type) !== -1"
				:type="fArch.type" :disabled="fArch.readonly" :readonly="fArch.readonly" :minlength="fArch.minlength"
				:maxlength="fArch.maxlength" />

			<b-form-input :id="currentId" :ref="currentId" v-model="workingValue" @blur="$emit('blur', $event)"
				@change="$emit('change', $event)" @focus="$emit('focus')" v-else type="text" :disabled="fArch.readonly"
				:readonly="fArch.readonly" :minlength="fArch.minlength" :maxlength="fArch.maxlength" />

		</b-form-group>

		<b-form-checkbox :id="currentId" :ref="currentId"
			v-if="fArch.key != 'id' && fArch.type == 'checkbox' && fArch.type != 'markdown'" :name="fArch.key"
			v-model="workingValue" value="1" unchecked-value="0">
			{{ finalLabel }}
		</b-form-checkbox>

		<div v-if="fArch.key != 'id' && fArch.type == 'markdown'">
			<textarea :id="currentId" :ref="currentId" v-model="workingValue" @blur="$emit('blur', $event)"
				@change="$emit('change', $event)" @focus="$emit('focus')" :disabled="fArch.readonly"
				:readonly="fArch.readonly"></textarea>
		</div>

	</div>
</template>

<script>

import _ from 'lodash'
import uiGroupingDefinition from './ui-grouping-definition.vue'
import quicktableSelect from './quicktableSelect'
import SimpleMDE from 'simplemde'
import imgInputAutoload from './img-input-autoload.vue';
import RemoteSelect from '@/views/elements/remote-select.vue';
import mobiscroll from '@mobiscroll/javascript';

import 'simplemde/dist/simplemde.min.css'

const capitalize = (str) => {
	if (typeof str === "string") {
		return str.replace(/^\w/, (c) => c.toUpperCase());
	} else {
		return "";
	}
}

export default {
	components: {
		uiGroupingDefinition,
		quicktableSelect,
		imgInputAutoload,
		RemoteSelect
	},
	name: "UIInputHandler",
	props: {
		args: {
            type: Object,
            default: () => { return {} }
        },
		fullFormGetter: {
			type: Function
		},
		grouping: {
			type: [Array, Object],
            default: () => { return [] }
		},	
		hash: {
			type: String // used to take full control of the input ID.
		},
		kIndex: {
			type: [Number, String],
		},
		fnToSelectFromMainQueryItem: {
			type: Function
		},
		dataValue: {
			type: String,
			default: 'value'
		},
		dataText: {
			type: String,
			default: 'text'
		},
		dataGroup: {
			type: String,
			default: 'grouping'
		},
		inputClass: {
			type: String,
			default: 'form-control form-select'
		},
		value: {
			type: [Object, String, Number, Boolean, Array]
		},
		fArch: {
			type: [Object],
			default: () => {
				return {
					key: 'indefined',
					type: null,
					label: null,
					default: null,
					readonly: null,
				};
			},
		}
	},
	data: () => {
		return {
			mobi: null,
			workingValue: null,
			SimpleMDE: null
		}
	},
	watch: {
		'fArch.options'() {
			this.reviewContent()
		},
		value() {
			if (this.fArch.type == 'selectmultiple' && this.value == null) this.workingValue = []
			else if (this.fArch.type == 'selectmultiple' && _.isString(this.value)) this.workingValue = this.value.split(',')
			else if (!!this.fArch.default && this.value == null) this.workingValue = _.clone(this.fArch.default)
			else this.workingValue = _.clone(this.value)
			if (_.isObjectLike(this.mobi))
				this.mobi.setVal(this.value, true, false)
		},
		workingValue() {
			if (this.fArch.type == 'selectmultiple' && _.isArray(this.workingValue))
				this.$emit('input', this.workingValue.join())
			else
				this.$emit('input', this.workingValue)
		}
	},
	computed: {
		uiHash(){
			return (this.hash)? this.hash : _.uniqueId('-ui');
		},
		currentId() {
			return 'form-' + this.fArch.key + this.uiHash
		},
		simpleLabel() {
			return (this.fArch.label) ? this.fArch.label : this.automateLabel(this.fArch.key)
		},
		finalLabel() {
			return this.simpleLabel
		}
	},
	methods: {
		/**
		 * loadSelectMobi
		 * 
		 * Carga el mobiscroll con preselección de dato desde workingValue.
		 * 
		 * @version 1.1
		 * @date 28 de agosto, 2024
		 */
		loadSelectMobi() {
			try {
				if (_.isObjectLike(this.mobi))
					this.mobi.destroy();

				// if (!this.fArch.readOnly)
				this.mobi = mobiscroll.select('#' + this.currentId, {
					display: 'bubble',
					disabled: this.fArch.readonly,
					filter: (this.fArch.options.length >= 10),
					inputClass: this.inputClass,
					filterPlaceholderText: 'Escribe para filtrar',
					group: (this.allowGrouping) ? this.groupConfig : false,
					multiline: !!this.fArch.multiline,
					groupLabel: 'as',
					dataGroup: this.dataGroup,
					dataValue: this.dataValue,
					dataText: this.dataText,
					readonly: this.fArch.readonly,
					readOnly: this.fArch.readonly,
					// data: this.fetchedOptions,
					// placeholder: this.placeholder,
					// onSet: (event, inst) => {
					// this.emit(inst.getVal())
					// }
				})
				let reSetValue,
					foundValue = _.find(this.fArch.options, item => {
						if (!!this.value && _.isObjectLike(item) && _.isString(item[this.dataValue]) &&  (item[this.dataValue]).toLowerCase().trim() == this.value.trim().toLowerCase())
							return item;
						else if (!!this.value && _.isString(item) && (item).toLowerCase().trim() == this.value.trim().toLowerCase())
							return item;
					});

				if (foundValue)
					reSetValue = (_.isObjectLike(foundValue) ? foundValue[this.dataValue] : foundValue);

				this.mobi.setVal(reSetValue, true);
			} catch (e) {
				console.warn(e)
			}
		},
		reviewContent() {
			if (this.fArch.type == 'select' && _.isArray(this.fArch.options))
				this.loadSelectMobi()
		},
		loadMarkDown() {

			this.SimpleMDE = new SimpleMDE({
				initialValue: this.workingValue,
				element: document.getElementById(this.currentId),
			})

			this.SimpleMDE.codemirror.on("change", (ab, inst) => {
				this.workingValue = this.SimpleMDE.value()
			});
		},
		isReadOnly() {
			return (this.fArch.readonly)
		},
		automateLabel(keyToName) {

			let labelName = null;
			labelName = capitalize(keyToName.replace(/\_/g, " "));

			switch (keyToName) {
				case "created":
					labelName = "Creación";
					break;
				case "modified":
					labelName = "Última edición";
					break;
			}

			return labelName;
		}
	},
	beforeMount() {
		this.workingValue = _.clone(this.value)
	},
	mounted() {
		this.reviewContent()
		if(_.isFunction(this.fullFormGetter))
			this.fullFormGetter()
		this.$nextTick(() => {
			// Fixes modal transition
			if (this.fArch.type == 'markdown')
				this.loadMarkDown()
		})
	},
	beforeDestroy() {
		if (_.isObjectLike(this.mobi))
			this.mobi.destroy();
	}
}

</script>
